/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type Subtype = typeof Subtype[keyof typeof Subtype];


export const Subtype = {
  AnniversaryBonusModuleSubtype: 'AnniversaryBonusModuleSubtype',
  BirthdayBonusModuleSubtype: 'BirthdayBonusModuleSubtype',
  ChecklistAnswerModuleSubtype: 'ChecklistAnswerModuleSubtype',
  DropdownAnswerModuleSubtype: 'DropdownAnswerModuleSubtype',
  DateModuleSubtype: 'DateModuleSubtype',
  EvaluationStarsModuleSubtype: 'EvaluationStarsModuleSubtype',
  EvaluationThumbsModuleSubtype: 'EvaluationThumbsModuleSubtype',
  PictureUploadModuleSubtype: 'PictureUploadModuleSubtype',
  PresenceQuotaModuleSubtype: 'PresenceQuotaModuleSubtype',
  SignatureControlModuleSubtype: 'SignatureControlModuleSubtype',
  TextAnswerModuleSubtype: 'TextAnswerModuleSubtype',
  WelcomeBonisoftModuleSubtype: 'WelcomeBonisoftModuleSubtype',
  MonthlyTaxFreeBenefitSubtype: 'MonthlyTaxFreeBenefitSubtype',
  MultiPictureUploadModuleSubtype: 'MultiPictureUploadModuleSubtype',
  LinkModuleSubtype: 'LinkModuleSubtype',
  SurveyAppointmentModuleSubtype: 'SurveyAppointmentModuleSubtype',
} as const;
